(ns web3.routers.intercom
  (:require [web3.components.intercom :as intercom]))

(def router
  {:paths
   ["" :intercom/show]

   :handlers
   {:intercom/show intercom/route-trigger}})